import React from 'react';
import AgedBalancesReport from '../../components/Finance/AgedBalancesReport';

export default function AgedReceivables() {
  return <AgedBalancesReport kind="receivables" />;
}
